import React from 'react'

import LoadingIndicator from '../components/LoadingIndicator'

class WithOpenMaps extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      reactLeaflet: null
    }
  }

  componentWillMount() {
    import(/* webpackChunkName: "react-leaflet" */ 'react-leaflet').then(exports => {
      this.setState({ reactLeaflet: exports })
    })
  }

  render() {
    const { reactLeaflet } = this.state
    const {
      component: Component,
      loadingComponent: LoadingComponent,
      ...rest
    } = this.props

    if (reactLeaflet) {
      console.log(reactLeaflet)
      const passedProps = { ...rest, ...reactLeaflet }

      return <Component {...passedProps} />
    }

    return (
      <LoadingComponent newSiteLook={dynamicValues.newSiteLook} unContained={false} />
    )
  }
}

export default (component, loadingComponent = LoadingIndicator) => {
  return props => (
    <WithOpenMaps {...props} component={component} loadingComponent={loadingComponent} />
  )
}
